import { jsx, jsxs } from "react/jsx-runtime";
import "react";
const SvgPerks = (props)=>/*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 17 24",
        ...props,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "url(#perks_svg__a)",
                d: "M3.438 16.222c0-.386.337-.699.752-.699h8.807c.416 0 .753.313.753.7v6.51c0 .475-.5.812-.988.664l-3.933-1.2a.8.8 0 0 0-.47 0l-3.934 1.2c-.487.148-.987-.189-.987-.664z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#perks_svg__b)",
                d: "M7.648.207a1.6 1.6 0 0 1 1.579 0l6.918 3.942c.453.259.73.72.73 1.218v8.013c0 .497-.277.959-.73 1.217l-6.918 3.942a1.6 1.6 0 0 1-1.579 0L.73 14.597A1.41 1.41 0 0 1 0 13.38V5.367c0-.498.277-.96.73-1.218z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#E91C24",
                d: "M10 8.201H7.188v2.636H10zM7.188 10.838H4.063v2.929h3.125zM12.813 10.838H10v2.929h2.813zM12.813 5.564H10v2.637h2.813zM7.188 5.564H4.063v2.637h3.125z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#fff",
                d: "M3.125 4.395h10.667v9.998H3.125z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#E91C24",
                d: "M7.004 8.03h2.91v2.727h-2.91zM4.095 10.757h2.91l-.001 2.727h-2.91zM9.913 10.757h2.909v2.727h-2.91zM9.913 5.303h2.909V8.03H9.913zM4.095 5.303h2.909V8.03h-2.91z"
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("radialGradient", {
                        id: "perks_svg__a",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 4.00196 -13.1932 0 8.594 18.912)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.345,
                                stopColor: "#2B2B2B"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#737373"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("radialGradient", {
                        id: "perks_svg__b",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(9.39124 0 0 8.80545 8.438 9.373)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#E91C24"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.56,
                                stopColor: "#E71B23"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.76,
                                stopColor: "#E01A21"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.9,
                                stopColor: "#D4171D"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#C61419"
                            })
                        ]
                    })
                ]
            })
        ]
    });
const perks = SvgPerks;
export { perks as default };
